import React from 'react';
import { connect } from 'react-redux';
import { IcoCheck } from '../../components/AppShell/icons';
import AppDownloadCard from '../../components/AppDownloadCard';

class AssessmentCompleted extends React.Component {
  handleContinue = () => {
    this.props.history.push('/dashboard/home');
  };

  render() {
    const name = this.props.auth?.user?.name;

    return (
      <div
        style={{
          minHeight: 'calc(100vh - 80px)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '32px 20px',
          background: 'var(--bg)',
        }}
      >
        <div
          style={{
            maxWidth: 420,
            width: '100%',
            textAlign: 'center',
          }}
        >
          {/* Check mark */}
          <div
            style={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              background: 'var(--success-soft)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 24px',
              color: 'var(--success)',
              fontSize: 28,
            }}
          >
            <IcoCheck size={28} />
          </div>

          <h1
            style={{
              fontSize: 24,
              fontWeight: 700,
              color: 'var(--fg)',
              marginBottom: 8,
            }}
          >
            You&apos;re all set{name ? `, ${name}` : ''}!
          </h1>
          <p
            style={{
              fontSize: 14,
              color: 'var(--fg-muted)',
              marginBottom: 40,
              lineHeight: 1.6,
            }}
          >
            Your trainer will review your profile and set up your
            program shortly.
          </p>

          {/* App download card (shared with the trainer welcome screen) */}
          <AppDownloadCard />

          <button
            className='btn btn-ghost'
            onClick={this.handleContinue}
            style={{ width: '100%', justifyContent: 'center' }}
          >
            Continue to dashboard →
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(AssessmentCompleted);
